<template>
  <va-dropdown class="profile-dropdown" v-model="isShown" boundary-body position="bottom" :offset="[0, 13]">
    <template #anchor>
      <span class="profile-dropdown__anchor">
        <slot />
        <va-icon class="px-2" :name="isShown ? 'angle_up' : 'angle_down'" :color="theme.primary" />
      </span>
    </template>
    <va-dropdown-content class="profile-dropdown__content">
      <va-list-item :key="admin">
        <label color="primary" class="md6 mr-2 dropdown_text" size="small" @click="adminPage">Admin</label>
      </va-list-item>
      <va-list-item :key="profile">
        <SignOutButton />
      </va-list-item>
    </va-dropdown-content>
  </va-dropdown>
</template>

<script>
import SignOutButton from "@/components/navbar/SignOutButton.vue";
import { useGlobalConfig } from 'vuestic-ui'

export default {
  name: 'profile-section',
  components: { SignOutButton },
  data() {
    return {
      isShown: false,
    }
  },
  computed: {
    theme() { return useGlobalConfig().getGlobalConfig() },
  },
  methods: {
    adminPage() {
      this.$router.push({ name: 'admin' }).catch(err => { })
    },
  },
}
</script>

<style lang="scss">
.va-dropdown__content,
.profile-dropdown__content {
  background: transparent !important;
  padding: 0px;
}

.va-dropdown__content {
  background: transparent !important;
}

button.va-button.va-button--default.va-button--small.md6.mr-2 {
  width: 80%;
}

.va-list-item {
  &__inner {
    background: rgb(48, 48, 66)
  }

}

.profile-dropdown {
  cursor: pointer;

  .va-dropdown-popper__anchor {
    display: flex;
    justify-content: flex-end;
  }

  &__content {
    width: 6rem;
  }

  &__item {
    display: block;
    color: var(--va-gray);

    &:hover,
    &:active {
      color: var(--va-primary);
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
